import { Switch } from "@headlessui/react";
import { Spinner } from "@via/components/loading/loading.tsx";
import { classNames } from "@via/utils/helpers.tsx";
import { type FC } from "react";

interface ToggleButtonProps {
  isOn: boolean;
  onToggle: (value: boolean) => void;
  className?: string;
  disabled?: boolean;
  isLoading?: boolean;
}

const ToggleButton: FC<ToggleButtonProps> = ({
  isOn,
  onToggle,
  className = "",
  disabled = false,
  isLoading = false,
}) => {
  const isDisabled = disabled || isLoading;

  return (
    <Switch
      checked={isOn}
      onChange={onToggle}
      className={classNames(
        "relative inline-flex h-6 w-12 items-center rounded-full transition-colors",
        isOn ? "bg-indigo-600" : "bg-gray-400",
        isDisabled ? "opacity-50 cursor-not-allowed" : "",
        className
      )}
      disabled={isDisabled}>
      <span
        className={classNames(
          "absolute left-1 flex h-4 w-4 items-center justify-center rounded-full bg-white transition",
          isOn ? "translate-x-6" : "translate-x-0"
        )}>
        {isLoading && (
          <Spinner
            loading
            spinColor="#e5e7eb"
            className="h-3 w-3 text-gray-400"
          />
        )}
      </span>
    </Switch>
  );
};

export default ToggleButton;
